export const STATUS_TYPE_DEUDOR = {
    PROVEEDOR_SRC: 'Proveedor SRC',
    CLIENTE_CORPORATIVO: 'Cliente Corporativo',
    CLIENTE_INDIVIDUAL_FILE: 'Cliente Individual (File)',
    PROVEEDOR_ADM: 'Proveedor ADM',
    OTRO: 'Otro'
} as const;

export const DEFAULT_INVOICE_RELATION_DEUDOR_TYPE =
    STATUS_TYPE_DEUDOR.CLIENTE_CORPORATIVO;

export const TYPE_DEPOSIT = {
    SAF: 'SAF',
    TRANSACCION: 'TRANSACCION'
} as const;